import { useTranslate } from '@tolgee/react';
import PayTypeCheckGroup from 'components/PayTypeCheckGroup';
import styled from '@emotion/styled';

export interface PayTypeCheckboxProps {
  payTypes: Pay.PayType[];
  value: Pay.PayType;
  onChange: (value: Pay.PayType) => void;
  currency: General.Currency;
  bank: Pay.PingpongBank;
  onBankChange: (value: Pay.PingpongBank) => void;
}

const PayTypeCheckbox = (props: PayTypeCheckboxProps) => {
  const { payTypes, ...otherProps } = props;
  const { t } = useTranslate();

  return (
    <div>
      <h4>{t('market.支付方式')}</h4>
      <PayType dataSource={payTypes} {...otherProps} />
    </div>
  );
};

export default PayTypeCheckbox;

const PayType = styled(PayTypeCheckGroup)`
  > ul > li {
    > label {
      border-radius: 4px;
    }
  }
`;
